import { differenceInMilliseconds } from 'date-fns';
const MS_PER_SECOND = 1000;
const secondsToMs = (seconds)=>Number.isFinite(seconds) && seconds >= 0 ? seconds * MS_PER_SECOND : null;
const httpDateToMs = (value, nowMs)=>{
    const at = Date.parse(value);
    return Number.isNaN(at) ? null : Math.max(0, differenceInMilliseconds(at, nowMs));
};
export const parseRetryAfterMs = (value, nowMs)=>{
    if (typeof value === 'number') return secondsToMs(value);
    if (typeof value !== 'string' || value.trim() === '') return null;
    const seconds = Number(value);
    return Number.isNaN(seconds) ? httpDateToMs(value, nowMs) : secondsToMs(seconds);
};
